import { Stack, Text } from "@fluentui/react";
import { lgRegisterConfigurationTotalNumberStyles, lgRegisterConfigurationTotalStyles, mdRegisterConfigurationTotalNumberStyles, mdRegisterConfigurationTotalStyles, registerConfigurationTotalContainerStyles, registerConfigurationTotalNumberStyles, registerConfigurationTotalStyles, smRegisterConfigurationTotalNumberStyles, smRegisterConfigurationTotalStyles, xlRegisterConfigurationTotalNumberStyles, xlRegisterConfigurationTotalStyles, xxlRegisterConfigurationTotalNumberStyles, xxlRegisterConfigurationTotalStyles } from "../Styles/RegisterConfigurationStyles";
import { useBreakpoint } from "../../../../Container/ContainerStyles";
import { BreakpointType } from "../../../../Container/ContainerFluid";
import { RegisterService } from "../../../Service/RegisterService";

export interface IRegisterConfigurationTotalProps {
    total: number;
    currency: string;
}

export const RegisterConfigurationTotal: React.FC<IRegisterConfigurationTotalProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            horizontal
            horizontalAlign="space-between"
            verticalAlign="center"
            verticalFill
            className={registerConfigurationTotalContainerStyles}
        >
            <Stack>
                <Text
                    className={
                        isSM ?
                            smRegisterConfigurationTotalStyles :
                        isMD ? 
                            mdRegisterConfigurationTotalStyles :
                        isLG ?
                            lgRegisterConfigurationTotalStyles :
                        isXL ?
                            xlRegisterConfigurationTotalStyles :
                        isXXL ?
                            xxlRegisterConfigurationTotalStyles 
                        :
                            registerConfigurationTotalStyles
                    }
                >
                    {RegisterService.translate("configuration:total")} 
                </Text>
            </Stack>
            <Stack>
                <Text
                    className={
                        isSM ?
                            smRegisterConfigurationTotalNumberStyles :
                        isMD ? 
                            mdRegisterConfigurationTotalNumberStyles :
                        isLG ?
                            lgRegisterConfigurationTotalNumberStyles :
                        isXL ?
                            xlRegisterConfigurationTotalNumberStyles :
                        isXXL ?
                            xxlRegisterConfigurationTotalNumberStyles 
                        :
                            registerConfigurationTotalNumberStyles
                    }
                >
                    {props.total}
                    {props.currency}
                </Text>
            </Stack>
        </Stack>
    );
};